import { MediaFile } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useMediaFile(ids: string[]) {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery<MediaFile[]>({
    queryKey: ["mediaFile", activeSessionId, ids],

    queryFn: async ({ signal }) => {
      if (!ids || ids.length === 0) {
        return [];
      }

      const promises = ids.map(async id => {
        const res = (await geotabClient.get("MediaFile", { id }, 1, signal))?.[0];
        return res;
      });

      const results = await Promise.all(promises);
      return results;
    },

    enabled: ids.length > 0,
  });
}
